<template>
	<div class="flex flex-col items-center gap-4 pb-6 font-[Inter]">
		<div
			class="
				flex h-40 w-full items-center justify-center bg-[#F5F3FF]
				bg-[linear-gradient(108.6deg,rgba(237,233,254,0.2)_0%,rgba(196,181,253,0.2)_100%)]
			"
		>
			<span class="inline-flex h-12 items-center gap-2.5 rounded-[10px] bg-[#DDD6FE] px-5">
				<SparklesIcon
					class="size-7 text-[#6D28D9]"
					aria-hidden="true"
				/>
				<span class="text-[28.76px] leading-[38px] font-medium text-[#6D28D9]">
					AutoApply
				</span>
			</span>
		</div>

		<div class="flex w-full flex-col gap-2 px-6 text-center">
			<h2 class="text-xl leading-7 font-semibold text-[#111827]">
				Your next application in under 5 minutes
			</h2>
			<p class="text-sm leading-5 text-[#6B7280]">
				AutoApply prepares a complete application for you in minutes, with your resume and cover letter tailored
				to the role and screening questions already answered. Just review and submit.
			</p>
		</div>

		<div class="flex w-full max-w-80 flex-col gap-2">
			<Button
				size="lg"
				class="w-full rounded-md"
				:disabled="isLoadingGate"
				@click="store.getStarted"
			>
				Get Started
			</Button>
			<Button
				size="lg"
				variant="ghost"
				class="w-full rounded-md bg-[#F3F4F6] text-[#111827] hover:bg-[#E5E7EB]"
				:disabled="isLoadingGate"
				@click="store.dismissPromo"
			>
				{{ isFinalPrompt ? "No thanks, don't remind me again" : 'Remind Me Later' }}
			</Button>
			<p
				v-if="gateError"
				role="alert"
				class="text-center text-sm text-red-600"
			>
				{{ gateError }}
			</p>
		</div>
	</div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { SparklesIcon } from '@heroicons/vue/24/outline';

import { Button } from '../../../components/ui/button';
import { useAutoApplyPromoStore } from '../../../store/auto-apply-promo.store';

const store = useAutoApplyPromoStore();
const { isFinalPrompt, isLoadingGate, gateError } = storeToRefs(store);
</script>
